function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "headphones"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 2935"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M2.49976 14.8489V9.89925C2.49976 7.93016 3.28993 6.04172 4.69645 4.64937C6.10298 3.25701 8.01063 2.47479 9.99976 2.47479C11.9889 2.47479 13.8965 3.25701 15.3031 4.64937C16.7096 6.04172 17.4998 7.93016 17.4998 9.89925V14.8489",
  stroke: "#767A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M17.4998 15.6738C17.4998 16.1114 17.3242 16.5311 17.0116 16.8405C16.699 17.1499 16.2751 17.3237 15.8331 17.3237H14.9998C14.5577 17.3237 14.1338 17.1499 13.8212 16.8405C13.5087 16.5311 13.3331 16.1114 13.3331 15.6738V13.199C13.3331 12.7614 13.5087 12.3418 13.8212 12.0324C14.1338 11.723 14.5577 11.5491 14.9998 11.5491H17.4998V15.6738ZM2.49976 15.6738C2.49976 16.1114 2.67535 16.5311 2.98791 16.8405C3.30047 17.1499 3.72439 17.3237 4.16642 17.3237H4.99976C5.44178 17.3237 5.86571 17.1499 6.17827 16.8405C6.49083 16.5311 6.66642 16.1114 6.66642 15.6738V13.199C6.66642 12.7614 6.49083 12.3418 6.17827 12.0324C5.86571 11.723 5.44178 11.5491 4.99976 11.5491H2.49976V15.6738Z",
  stroke: "#767A8A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const SvgHeadphones = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeadphones, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/headphones.e91ee657.svg";
export { ForwardRef as ReactComponent };